import Vue from 'vue'
import Router from 'vue-router'
import postsListing from '@/pages/postsListing'
import postPage from '@/pages/postPage'
import pageNotFound from '@/pages/pageNotFound'
import homePage from '@/pages/homePage'

Vue.use(Router)

// Define routes
const router = new Router({
	mode: 'history', /* Removes hash from URL */
	routes: [
		{
			path: '/',
			name: 'Index',
			component: homePage
		},
		{
			path: '/post/:slug',
			name: 'Post',
			component: postPage
		},
		{
			path: '/404',
			alias: '*',
			name: 'pageNotFound',
			component: pageNotFound
		}
	]
})

// On page transition, reset vertical scroll
router.beforeEach((to, from, next) => {
	window.scrollTo(0, 0)
	next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js